import { TopNavigation, TopNavigationContextType } from '@numa-group/ui.top-navigation';

import { useBrand } from '@src/contexts/brand-context';
import { useCmsContent } from '@src/contexts/cms-content-context';

type NavigationNativeProps = {
  languageSwitcher: JSX.Element;
  isMyTripsPage: boolean;
  content: TopNavigationContextType['content'];
  user?: { firstName: string; lastName: string };
  onLogout: () => void;
};

export const NavigationNative = ({
  languageSwitcher,
  isMyTripsPage,
  content,
  user,
  onLogout,
}: NavigationNativeProps) => {
  const cmsContent = useCmsContent();
  const { brand } = useBrand();

  return (
    <>
      <TopNavigation
        position="sticky"
        content={content}
        style={{ borderBottom: '1px solid var(--color-numa-black--200)' }}
      >
        <TopNavigation.Logo {...brand.logo} href={brand.websiteUrl || '/trips'} desktopOnly />
        <TopNavigation.MobileBackButton href="/trips" />

        <TopNavigation.Links>
          <TopNavigation.Link href="/trips" isActive={isMyTripsPage}>
            {cmsContent.navigationTrips}
          </TopNavigation.Link>
        </TopNavigation.Links>

        <TopNavigation.Settings>{languageSwitcher}</TopNavigation.Settings>

        {user ? (
          <TopNavigation.AccountBadge user={user} accountHref="/profile" onLogout={onLogout} />
        ) : (
          <TopNavigation.SignUpLink href="/auth">{cmsContent.misc.signup}</TopNavigation.SignUpLink>
        )}
      </TopNavigation>
    </>
  );
};
